import React, { Component, Fragment } from "react";
import { isEmpty } from "lodash";
import { Redirect } from "react-router-dom";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  Grid,
  Box,
  Fab,
  CardHeader,
  Typography,
  IconButton,
} from "@mui/material";
import {
  CloudDownloadRounded,
  LocalOfferRounded,
  AccountBalanceWalletRounded,
  HomeRounded,
  PeopleRounded,
  RestoreRounded,
  CreateNewFolderRounded,
  CreditCardRounded,
  CardGiftcardRounded,
  AssignmentIndRounded,
  BusinessRounded,
  PieChartRounded,
  BarChartOutlined,
  CategoryRounded,
  DateRangeRounded,
  ListAltRounded,
  DonutLargeRounded,
  MoneyRounded,
  MonetizationOnRounded,
  CompareArrowsRounded,
  ErrorOutlineRounded,
  ConstructionRounded,
  RoofingRounded,
  BadgeRounded,
  ReceiptLongRounded,
  ChatBubbleRounded,
  ChairRounded,
  PaymentsRounded,
  CardTravelRounded,
  ApartmentRounded,
  DeviceUnknownRounded,
  QuizRounded,
  BugReportRounded,
  Inventory2Rounded,
} from "@mui/icons-material";
import GroupsIcon from '@mui/icons-material/Groups';

import {
  fetchAdminSpendings,
  deleteSpending,
  fetchSpendingPayments,
  updateSpending,
  newSpending,
} from "../../store/actions/spendingAction";
import JiraForm from "../common/JiraForm";
import {
  fetchUsersByEmail,
  fetchUsers,
  newUser,
  deleteUser,
  updateUser,
  updateUserPassword,
} from "../../store/actions/userAction";
import {
  fetchParentCategories,
  fetchChildCategories,
  newCategory,
  updateCategory,
  toggleCategoryActive,
  newBudget,
  fetchBudgets,
  fetchParentCategoriesSpent,
  updateActiveBudget,
} from "../../store/actions/categoriesAction";
import {
  fetchSuppliers,
  newSupplier,
  updateSupplier,
} from "../../store/actions/suppliersAction";
import {
  fetchLabels,
  newLabel,
  updateLabel,
} from "../../store/actions/labelsAction";
import {
  fetchBanks,
  newBank,
  updateBank,
} from "../../store/actions/banksAction";
import {
  fetchPayments,
  newPayment,
  newPaymentFullSupplier,
  updatePayment,
  fetchPaymentDetails,
  newPaymentCharge,
  newPaymentSalary,
  deletePayment,
} from "../../store/actions/paymentAction";
import {
  fetchCredits,
  newCredit,
  newSubCredit,
  fetchSubCredits,
  fetchDebits,
  newDebit,
  updateDebit,
  recalcCredits,
  deleteCredit,
  deleteDebit,
} from "../../store/actions/creditAction";
import {
  fetchProjectSteps,
  newProjectStep,
  deleteProjectStep,
} from "../../store/actions/projectStepAction";
import {
  fetchEmployees,
  newEmployee,
  updateEmployee,
  fetchServices,
  newService,
  fetchFunctions,
  newFunction,
} from "../../store/actions/employeeAction";
import {
  fetchSalaries,
  newSalary,
  updateSalary,
  deleteSalary,
  fetchCharges,
} from "../../store/actions/salariesAction";
import {
  fetchSalaryCats,
  newSalaryCat,
  updateSalaryCat,
} from "../../store/actions/salaryCatsAction";
import {
  newAccess,
  fetchAccess,
  updateAccess,
  deleteAccess,
} from "../../store/actions/accessAction";
import {
  newProject,
  fetchProjects,
  updateProject,
  addSpendingToProject,
} from "../../store/actions/projectAction";
import {
  fetchChantiers,
  updateChantier,
  addSpendingToChantier,
  getChantierPartList,
} from "../../store/actions/chantierAction";
import {
  fetchTimesheets,
  updateTimesheet,
  newTimesheet,
} from "../../store/actions/timesheetAction";
import {
  fetchSupplierAdvances,
  deleteSupplierAdvance,
  newSupplierAdvance,
  newAdvanceReturn,
  fetchAdvanceReturns,
  deleteAdvanceReturn,
} from "../../store/actions/suppliersAction";
import {
  newPost,
  fetchPosts,
  updatePost,
  deletePost,
  newIncome,
  updateIncome,
  fetchIncomePayments,
  fetchIncomes,
  deleteIncome,
  importIncomes,
} from "../../store/actions/incomesAction";
import {
  newFacture,
  updateFacture,
  fetchFactures,
  deleteFacture,
} from "../../store/actions/facturesAction";
import {
  newTransfer,
  updateTransfer,
  fetchTransfers,
  deleteTransfer,
} from "../../store/actions/transfersAction";
import {
  newEquipement,
  newVehicule,
  updateEquipement,
  fetchEquipements,
  fetchVehicules,
  updateVehicule,
  updateEquipementPics,
  updateVehiculePics,
  deleteEquipement,
  fetchImmoTags,
} from "../../store/actions/equipementAction";
import {
  newLocalisation,
  updateLocalisation,
  fetchParentLocalisations,
  fetchChildLocalisations,
} from "../../store/actions/localisationAction";
import {
  newLoan,
  // updateLoan,
  updateResaLoanUser,
  updateResaLoanAdmin,
  endLoan,
  fetchLoans,
  fetchEquipementLoans,
  fetchUserLoansAdmin,
  newLoanDemand,
  updateLoanDemand,
  fetchLoanDemands,
  fetchEquipementLoanDemands,
  fetchUserLoanDemandsAdmin,
  updateDemandLoanStatus,
  newLoanResa,
  updateDeleteLineAdmin,
} from "../../store/actions/loanAction";
import {
  newArticle,
  updateArticle,
  fetchArticles,
  updateArticlePics,
  newSession,
  updateSession,
  updateSessionStatus,
  fetchSessions,
  newUserDemand,
  updateUserDemand,
  fetchAllDemands,
} from "../../store/actions/demandAction";

import { fetchAdminSpendingsDemand, fetchSingleSpendingDemand } from "../../store/actions/spendingDemandAction";

import SideBar from "../../container/layouts/SideBarOld";
import UsersList from "./Users/UsersList";
import CategoriesList from "./Categories/CategoriesList";
import CategoriesForm from "./Categories/CategoriesForm";
import SuppliersList from "./Suppliers/SuppliersList";
import DoughnutChart from "../Stats/DoughnutChart";
import LabelsList from "./Labels/LabelsList";
import Notif from "../common/Notif";
import BanksList from "./Banks/BanksList";
import PaymentsList from "./Payments/PaymentsList";
import { Months, firstDayOfYear } from "../Stats/statsFunctions";
import SpendingsAdmin from "./Spendings/SpendingsAdmin";
import SpendingsDemandAdmin from "./SpendingsDemand/SpendingsDemandAdmin";
import CreditsList from "./Credits/CreditsList";
import ExtractsList from "./Extracts/ExtractsList";
import SalariesList from "./Salary/SalariesList";
import EmployeeForm from "./Salary/EmployeeForm";
import SuppliersForm from "./Suppliers/SuppliersForm";
import DatePicker from "../common/DatePicker";
import Dialog from "../common/Dialog";
// import StackedStats from '../Stats/StackedStats';
import StackedGeneral from "../Stats/StackedGeneral";
import { InputSelectNative } from "../common/Form";
import DownloadProgress from "./Extracts/DownloadProgress";
import Spinner from "../common/Spinner";
import ProjectsList from "./Projects/ProjectsList";
import PaymentsGeneral from "./Payments/PaymentsGeneral";
import ScheduleAdmin from "./Timesheet/ScheduleAdmin";
import BudgetGeneral from "./Budget/BudgetGeneral";
import IncomesList from "./Incomes/IncomesList";
import TransfersList from "./Transfers/TransfersList";
import ChantiersList from "./Chantiers/ChantiersList";
import FacturesList from "./Factures/FacturesList";
import AdvancesGeneral from "./Advances/AdvancesGeneral";
import CreditsGeneral from "./Credits/CreditsGeneral";
import EquipementGeneral from "./Equipements/EquipementGeneral";
import Society from "./Society/Society";
import DemandGeneral from "./Demands/DemandGeneral";
import EquipementUsers from "./Equipements/EquipementUsers";
import AddCardIcon from '@mui/icons-material/AddCard';
import IframeV1 from "./IFrame/Iframe";
// import ImportCSV from './Import/ImportCSV';
// import Tests8000 from './Tests8000';


class PageNotFound extends Component {
  state = {};
  render() {
    return (
      <Box p={8} textAlign="center">
        <IconButton>
          <ErrorOutlineRounded fontSize="large" color="error" />
        </IconButton>
        <Typography variant="h4">Page Not Found</Typography>
      </Box>
    );
  }
}

class Dashboard extends Component {
  state = {
    filter_payment: "all",
    filter_period: "currentMonth",
    start_date: firstDayOfYear,
    end_date: new Date(),
    openForm: false,
    chart: "donut",
  };

  componentDidMount() {
    fetchAdminSpendingsDemand();
    window.scrollTo(0, 0);

  }
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
    if (value === "year") {
      this.setState({
        start_date: firstDayOfYear,
        end_date: new Date(),
      });
    }
  };

  render() {
    return (
      <Box>
        {this.props.isUserPlus ? (
          <Box p={8} textAlign="center">
            {/* <IconButton><ErrorOutlineRounded fontSize="large" color="error"/></IconButton> */}
            <Typography variant="h4">Espace Admin</Typography>
          </Box>
        ) : (
          <Box>
            <CardHeader
              action={
                this.state.chart === "donut" ? (
                  <Fab
                    onClick={() => this.setState({ chart: "bar" })}
                    color="secondary"
                    size="small"
                  >
                    <BarChartOutlined />
                  </Fab>
                ) : (
                  <Fab
                    onClick={() => this.setState({ chart: "donut" })}
                    color="primary"
                    size="small"
                  >
                    <PieChartRounded />
                  </Fab>
                )
              }
              title="Répartition des Dépenses"
            />
            {this.props.STATE.spendings.fetching ? (
              <Spinner />
            ) : (
              <Box p={1}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <InputSelectNative
                      label="État Paiement"
                      onChange={this.handleChange}
                      value={this.state.filter_payment}
                      labelWidth={110}
                      name="filter_payment"
                      id="filter_payment"
                      options={[
                        <option value="all">Toutes les dépenses</option>,
                        <option value="fully_paid">Payés</option>,
                        <option value="rest_to_pay">À payer</option>,
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputSelectNative
                      label="Période"
                      onChange={this.handleChange}
                      value={this.state.filter_period}
                      labelWidth={60}
                      name="filter_period"
                      id="filter_period"
                      options={[
                        <option value="week">7 derniers jours</option>,
                        <option value="currentMonth">
                          {Months[new Date().getMonth()]}
                        </option>,
                        <option value="year">
                          {new Date().getFullYear()}
                        </option>,
                        <option value="custom">Autre</option>,
                      ]}
                    />
                  </Grid>
                  {this.state.filter_period === "custom" && (
                    <Fragment>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          required
                          label="Du"
                          handleChange={(date) =>
                            this.setState({ start_date: date })
                          }
                          value={this.state.start_date}
                          id="start_date"
                          maxDate={this.state.end_date || new Date()}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          required
                          label="Au"
                          handleChange={(date) =>
                            this.setState({ end_date: date })
                          }
                          value={this.state.end_date}
                          id="end_date"
                          maxDate={new Date()}
                          minDate={this.state.start_date || new Date()}
                        />
                      </Grid>
                    </Fragment>
                  )}
                </Grid>
                {this.state.chart === "donut" && (
                  <DoughnutChart
                    view="ADMIN"
                    {...this.state}
                    openFormCustom={this.props.openFormCustom}
                  />
                )}
                {this.state.chart === "bar" && (
                  <StackedGeneral {...this.props} {...this.state} />
                )}
              </Box>
            )}
          </Box>
        )}
      </Box>
    );
  }
}

class AdminDashboard extends Component {
  state = {
    notif: {
      openNotif: false,
      variant: "",
      message: "",
    },
    newCatName: "",
    openNewCategory: false,
    newSupplierName: "",
    openNewSupplier: false,
    newEmployeeName: "",
    openNewEmployee: false,
    url: "",
    downloading: false,
    title: "",
    titleDialog: "",
    start_date: firstDayOfYear,
    end_date: new Date(),
    budget_year: "",
    isBudget: false,
    formDownload: false,
    project_id: "",
    bank_id: "",
    op_id: "",
    op_type: "",
    user_id: "",
    refreshKey: 0,
  };

  componentDidMount = async () => {
    const { currentUser, ACCESS } = this.props;
    const params = new URLSearchParams(window.location.search);
    const spendingDemandId = params.get('spending_demand_id');
    this.setState({
      spendingDemandId: spendingDemandId,
    });
    
    // Écouter les changements de token pour rafraîchir les iframes
    this.setupTokenChangeListener();

    this.refreshIframe();
    
    // Appeler la logique restante du componentDidMount
    this.componentDidMountLogic();
  }

  componentWillUnmount() {
    // Nettoyer l'écouteur d'événements
    this.removeTokenChangeListener();
  }

  // Méthode pour écouter les changements de token
  setupTokenChangeListener = () => {
    window.addEventListener('tokenChanged', this.handleTokenChange);
  }

  // Méthode pour supprimer l'écouteur d'événements
  removeTokenChangeListener = () => {
    window.removeEventListener('tokenChanged', this.handleTokenChange);
  }

  // Gérer les changements de token
  handleTokenChange = (e) => {
    console.log('AdminDashboard: Token changé, rafraîchissement des iframes');
    // Forcer le rafraîchissement de toutes les iframes
    this.refreshIframe();
    
    // Optionnel: utiliser la méthode statique pour rafraîchir toutes les iframes
    if (window.IframeV1 && window.IframeV1.refreshAllIframes) {
      window.IframeV1.refreshAllIframes();
    }
  }

  // Suite du code du componentDidMount
  componentDidMountLogic = () => {
    // console.log('====================================');
    // console.log({ currentUser, ACCESS });
    // console.log('====================================');
    if (this.props.isAdmin) {
      if (isEmpty(this.props.ACCESS)) {
        this.props.fetchAccess();
      }
      if (isEmpty(this.props.SPENDINGS)) {
        this.props.fetchSpendings();
      }
      if (isEmpty(this.props.USERS)) {
        this.props.fetchUsers();
      }
      if (isEmpty(this.props.CATEGORIES.PARENT)) {
        this.props.fetchParentCategories();
      }
      if (isEmpty(this.props.CATEGORIES.CHILD)) {
        this.props.fetchChildCategories();
      }
      if (isEmpty(this.props.BANKS)) {
        this.props.fetchBanks();
      }
      if (isEmpty(this.props.PAYMENTS)) {
        this.props.fetchPayments();
      }
      if (isEmpty(this.props.PAYMENT_DETAILS)) {
        this.props.fetchPaymentDetails();
      }
      if (isEmpty(this.props.SUPPLIERS)) {
        this.props.fetchSuppliers();
      }
      if (isEmpty(this.props.LABELS)) {
        this.props.fetchLabels();
      }
      if (isEmpty(this.props.CREDITS)) {
        this.props.fetchCredits();
      }
      if (isEmpty(this.props.DEBITS)) {
        this.props.fetchDebits();
      }
      if (isEmpty(this.props.EMPLOYEES)) {
        this.props.fetchEmployees();
      }
      if (isEmpty(this.props.SALARIES)) {
        this.props.fetchSalaries();
      }
      if (isEmpty(this.props.SALARY_CATS)) {
        this.props.fetchSalaryCats();
      }
      if (isEmpty(this.props.CHARGES)) {
        this.props.fetchCharges();
      }
      if (isEmpty(this.props.SERVICES)) {
        this.props.fetchServices();
      }
      if (isEmpty(this.props.FUNCTIONS)) {
        this.props.fetchFunctions();
      }
      if (isEmpty(this.props.PROJECTS)) {
        this.props.fetchProjects();
      }
      // if(isEmpty(this.props.CHANTIERS)){
      //     this.props.fetchChantiers()
      // }
      // in bank single
      // if(isEmpty(this.props.TRANSFERS)){
      //     this.props.fetchTransfers()
      // }
      // if(isEmpty(this.props.INCOMES)){
      //     this.props.fetchIncomes()
      // }
      // if(isEmpty(this.props.POSTS)){
      //     this.props.fetchPosts()
      // }
    }
  };

  refreshIframe = () => {
    this.setState(prevState => ({ refreshKey: prevState.refreshKey + 1 }));
  };

  createNewCategory = (name) => {
    console.log("====================================");
    console.log("create new Cat ", name);
    console.log("====================================");
    this.setState({ openNewCategory: true, newCatName: name });
  };
  createNewSupplier = (name) => {
    console.log("====================================");
    console.log("create new Supplier ", name);
    console.log("====================================");
    this.setState({ openNewSupplier: true, newSupplierName: name });
  };
  createNewEmployee = (name) => {
    console.log("====================================");
    console.log("create new Employee ", name);
    console.log("====================================");
    this.setState({ openNewEmployee: true, newEmployeeName: name });
  };
  handleDownloadDemandSession = (
    url,
    title = this.state.title,
    session_id = this.state.session_id
  ) => {
    console.log("====================================");
    console.log({ url, title, session_id });
    console.log("====================================");
    this.setState({
      url,
      title,
      session_id,
      formDownload: false,
      downloading: true,
      isBudget: false,
    });
  };
  handleDownloadBudget = (url, title, budget_year) => {
    console.log("====================================");
    console.log({ url, title, budget_year });
    console.log("====================================");
    this.setState({
      url,
      title,
      budget_year,
      formDownload: false,
      downloading: true,
      isBudget: true,
    });
  };
  handleDownload = (
    url,
    title = this.state.title,
    start_date = this.state.start_date,
    end_date = this.state.end_date,
    project_id = this.state.project_id
  ) => {
    if (this.state.op_id && this.state.op_type) {
      this.handleDownloadCustom();
    } else {
      console.log("====================================");
      console.log({ url, title });
      console.log("====================================");
      this.setState({
        url,
        title,
        start_date,
        end_date,
        project_id,
        formDownload: false,
        downloading: true,
        isBudget: false,
      });
    }
  };
  handleDownloadCustom = (
    title = this.state.title,
    start_date = this.state.start_date,
    end_date = this.state.end_date,
    op_id = this.state.op_id,
    op_type = this.state.op_type
  ) => {
    console.log("====================================");
    console.log({ title });
    console.log("====================================");
    this.setState({
      url: "/extract/spendings/custom",
      title,
      start_date,
      end_date,
      op_id,
      op_type,
      formDownload: false,
      downloading: true,
      isBudget: false,
    });
  };
  handleDownloadUserHistory = (url, title = this.state.title, user_id) => {
    console.log("====================================");
    console.log({ url, title });
    console.log("====================================");
    this.setState({
      url,
      title,
      user_id,
      formDownload: false,
      downloading: true,
      isBudget: false,
    });
  };

  notif = (variant, message) => {
    console.log("==================NOTIF==================");
    console.log(variant, message);
    console.log("====================================");
    this.setState({
      notif: {
        openNotif: true,
        variant,
        message,
      },
    });
  };
  handleCloseNotif = () => {
    this.setState({
      notif: {
        openNotif: false,
        variant: "",
        message: "",
      },
    });
  };

  render() {
    // console.log('================= STATE ===================');
    // console.log(this.state);
    // console.log('====================================');
    const { page } = this.props.match.params;
    // console.log('====================================');
    // console.log({page}, this.props.match);
    // console.log('====================================');
    const { currentUser, ACCESS } = this.props;
    const { variant, message, openNotif } = this.state.notif;
    const {
      openNewCategory,
      newCatName,
      openNewSupplier,
      newSupplierName,
      newEmployeeName,
      openNewEmployee,
    } = this.state;
    let menuList = [
      // { page: "dashboard", default: "Dashboard", icon:<HomeRounded color={(page === "dashboard" ? "secondary" : "")}/>, to: "/admin/dashboard" },
    ];
    let subMenuList = [];

    const ADMIN_MENU = {
      dashboard: {
        page: "dashboard",
        default: "Dashboard",
        icon: <HomeRounded color={page === "dashboard" ? "secondary" : ""} />,
        to: "/admin/dashboard",
      },
      users: {
        page: "users",
        default: "Utilisateurs",
        icon: <PeopleRounded color={page === "users" ? "secondary" : ""} />,
        to: "/admin/users",
      },
      spendings: {
        page: "spendings",
        default: "Dépenses",
        icon: (
          <RestoreRounded color={page === "spendings" ? "secondary" : ""} />
        ),
        to: "/admin/spendings",
      },
      spendings_demand: {
        page: "spendings_demand",
        default: "Demandes de Dépenses",
        icon: (
          <AddCardIcon
            color={page === "spendings_demand" ? "secondary" : ""}
          />
        ),
        to: "/admin/spendings_demand",
      },

      teams: {
        page: "teams",
        default: "Équipes",
        icon: <GroupsIcon color={page === "teams" ? "secondary" : ""} />,
        to: "/admin/teams",
      },
      categories: {
        page: "categories",
        default: "Catégories",
        icon: (
          <CreateNewFolderRounded
            color={page === "categories" ? "secondary" : ""}
          />
        ),
        to: "/admin/categories",
      },
      suppliers: {
        page: "suppliers",
        default: "Fournisseurs",
        icon: (
          <BusinessRounded color={page === "suppliers" ? "secondary" : ""} />
        ),
        to: "/admin/suppliers",
      },
      labels: {
        page: "labels",
        default: "Labels",
        icon: (
          <LocalOfferRounded color={page === "labels" ? "secondary" : ""} />
        ),
        to: "/admin/labels",
      },
      banks: {
        page: "banks",
        default: "Banques",
        icon: (
          <AccountBalanceWalletRounded
            color={page === "banks" ? "secondary" : ""}
          />
        ),
        to: "/admin/banks",
      },
      transfers: {
        page: "transfers",
        default: "Transfert de fonds",
        icon: (
          <CompareArrowsRounded
            color={page === "transfers" ? "secondary" : ""}
          />
        ),
        to: "/admin/transfers",
      },
      payments: {
        page: "payments",
        default: "Paiements",
        icon: (
          <CreditCardRounded color={page === "payments" ? "secondary" : ""} />
        ),
        to: "/admin/payments",
      },
      advances: {
        page: "advances",
        default: "Acomptes",
        icon: (
          <CardTravelRounded color={page === "advances" ? "secondary" : ""} />
        ),
        to: "/admin/advances",
      },
      credits: {
        page: "credits",
        default: "Avances",
        icon: (
          <CardGiftcardRounded color={page === "credits" ? "secondary" : ""} />
        ),
        to: "/admin/credits",
      },
      projects: {
        page: "projects",
        default: "Projets",
        icon: (
          <CategoryRounded color={page === "projects" ? "secondary" : ""} />
        ),
        to: "/admin/projects",
      },
      projects_archived: {
        page: "projects_archived",
        default: "Projets Archivés",
        icon: (
          <Inventory2Rounded
            color={page === "projects_archived" ? "secondary" : ""}
          />
        ),
        to: "/admin/projects_archived",
      },
      chantiers: {
        page: "chantiers",
        default: "Chantiers",
        icon: (
          <RoofingRounded color={page === "chantiers" ? "secondary" : ""} />
        ),
        to: "/admin/chantiers",
      },
      schedule: {
        page: "schedule",
        default: "Planning",
        icon: (
          <DateRangeRounded color={page === "schedule" ? "secondary" : ""} />
        ),
        to: "/admin/schedule",
      },
      extracts: {
        page: "extracts",
        default: "Extract",
        icon: (
          <CloudDownloadRounded
            color={page === "extracts" ? "secondary" : ""}
          />
        ),
        to: "/admin/extracts",
      },
      // imports: { page: "imports", default: "Import", icon:<CloudDownloadRounded color={(page === "imports" ? "secondary" : "")}/>, to: "/admin/imports" },
      salary: {
        page: "salary",
        default: "Salaires",
        icon: <BadgeRounded color={page === "salary" ? "secondary" : ""} />,
        to: "/admin/salary",
      },
      budget: {
        page: "budget",
        default: "Budget",
        icon: (
          <DonutLargeRounded color={page === "budget" ? "secondary" : ""} />
        ),
        to: "/admin/budget",
      },
      incomes: {
        page: "incomes",
        default: "Recettes",
        icon: (
          <MonetizationOnRounded
            color={page === "incomes" ? "secondary" : ""}
          />
        ),
        to: "/admin/incomes",
      },
      factures: {
        page: "factures",
        default: "Factures",
        icon: (
          <ReceiptLongRounded color={page === "factures" ? "secondary" : ""} />
        ),
        to: "/admin/factures",
      },
      equipements: {
        page: "equipements_gen",
        default: "Immos et Matériels",
        icon: (
          <ChairRounded color={page === "equipements" ? "secondary" : ""} />
        ),
        to: "/admin/equipements",
        sub: [
          {
            page: "equipements",
            default: "Liste",
            icon: (
              <ChairRounded color={page === "equipements" ? "secondary" : ""} />
            ),
            to: "/admin/equipements",
          },
          {
            page: "equipemployees",
            default: "Employés",
            icon: (
              <ChairRounded
                color={page === "equipemployees" ? "secondary" : ""}
              />
            ),
            to: "/admin/equipemployees",
          },
        ],
      },
      society: {
        page: "society",
        default: "Entreprise",
        icon: (
          <ApartmentRounded color={page === "society" ? "secondary" : ""} />
        ),
        to: "/admin/society",
      },
      demands: {
        page: "demands",
        default: "Demandes",
        icon: <QuizRounded color={page === "demands" ? "secondary" : ""} />,
        to: "/admin/demands",
      },
      feature_request: {
        page: "feature_request",
        default: "Demande de Fonctionnalité",
        icon: <BugReportRounded color={page === "feature_request" ? "secondary" : ""} />,
        to: "/admin/feature_request",
      },
    };

    if (currentUser.user_type && !isEmpty(ACCESS) && ACCESS[currentUser.user_type] && ACCESS[currentUser.user_type].access_pages) {
      if (!ACCESS[currentUser.user_type].access_pages.includes("dashboard")) {
        // if (currentUser.user_role !== 10){
        menuList.push(ADMIN_MENU["dashboard"]);
      }
      ACCESS[currentUser.user_type].access_pages?.forEach((page) => {
        menuList.push(ADMIN_MENU[page]);
        if (page === "spendings") {
          menuList.push(ADMIN_MENU["spendings_demand"]);
        }
        if (page === "users") {
          menuList.push(ADMIN_MENU["teams"]);
        }
      });

      if (this.props.isSuperAdmin) {
        menuList.push(ADMIN_MENU["society"]);
      }
    } else {
      menuList.push(
        ADMIN_MENU["dashboard"],
        ADMIN_MENU["users"],
        ADMIN_MENU["teams"],
        ADMIN_MENU["spendings"],
        ADMIN_MENU["spendings_demand"],
        ADMIN_MENU["categories"],
        ADMIN_MENU["suppliers"],
        ADMIN_MENU["labels"],
        ADMIN_MENU["banks"],
        ADMIN_MENU["payments"],
        ADMIN_MENU["advances"],
        ADMIN_MENU["credits"],
        ADMIN_MENU["projects"],
        ADMIN_MENU["chantiers"],
        ADMIN_MENU["factures"],
        ADMIN_MENU["incomes"],
        ADMIN_MENU["transfers"]
        // ADMIN_MENU["imports"],
        // ADMIN_MENU["extracts"],
        // ADMIN_MENU["salary"],
        // ADMIN_MENU["budget"],
      );

      this.props.isSuper &&
        menuList.push(
       
          ADMIN_MENU["schedule"],
          ADMIN_MENU["extracts"],
          ADMIN_MENU["equipements"],
          // ADMIN_MENU["imports"],
          ADMIN_MENU["salary"],
          ADMIN_MENU["budget"],
          ADMIN_MENU["demands"],
          ADMIN_MENU["society"],

        );
    }

    if (!menuList.includes(ADMIN_MENU["feature_request"])) {
      menuList.push(ADMIN_MENU["feature_request"]);
    }

 
    if (
      page === "projects_archived" &&
      !menuList.includes(ADMIN_MENU["projects_archived"])
    ) {
      menuList.push(ADMIN_MENU["projects_archived"]);
    }

    if (menuList.includes(ADMIN_MENU["equipements"])) {
      subMenuList.push("equipemployees");
    }
    // console.log('====================================');
    // console.log({menuList});
    // console.log('====================================');
    return (
      <SideBar toto admin page={page} menu={menuList} {...this.props}>
        {openNotif && variant && message && (
          <Notif
            open={true}
            {...this.state.notif}
            onClose={this.handleCloseNotif}
          />
        )}
        {openNewCategory && (
          <CategoriesForm
            open={true}
            handleClose={() =>
              this.setState({ openNewCategory: false, newCatName: newCatName })
            }
            category={{ category_name: newCatName }}
            notif={this.notif}
            {...this.props}
          />
        )}
        {openNewSupplier && (
          <SuppliersForm
            open={true}
            handleClose={() =>
              this.setState({
                openNewSupplier: false,
                newSupplierName: newSupplierName,
              })
            }
            supplier={{ supplier_name: newSupplierName }}
            notif={this.notif}
            {...this.props}
          />
        )}
        {openNewEmployee && (
          <EmployeeForm
            open={true}
            handleClose={() =>
              this.setState({
                openNewEmployee: false,
                newEmployeeName: newEmployeeName,
              })
            }
            employee={{ employee_lastname: newEmployeeName }}
            notif={this.notif}
            {...this.props}
          />
        )}
        {this.state.formDownload && (
          <Dialog
            submitAction={() => this.handleDownload(this.state.url)}
            close={() =>
              this.setState({
                formDownload: false,
                url: "",
                title: "",
                op_type: "",
                op_id: "",
                project_id: "",
                chantier_id: "",
              })
            }
            submitTitle="Télécharger"
            title={this.state.titleDialog}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <DatePicker
                  required
                  label="Du"
                  handleChange={(date) => this.setState({ start_date: date })}
                  value={this.state.start_date}
                  id="start_date"
                  maxDate={this.state.end_date || new Date()}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DatePicker
                  required
                  label="Au"
                  handleChange={(date) => this.setState({ end_date: date })}
                  value={this.state.end_date}
                  id="end_date"
                  maxDate={new Date()}
                  minDate={this.state.start_date || new Date()}
                />
              </Grid>
            </Grid>
          </Dialog>
        )}
        {this.state.downloading && this.state.url && (
          <DownloadProgress
            {...this.state}
            clearData={() =>
              this.setState({ url: "", title: "", op_id: "", op_type: "" })
            }
            handleLoading={(downloading) => this.setState({ downloading })}
          />
        )}
        {
          page === "dashboard" &&
            menuList.includes(ADMIN_MENU["dashboard"]) && (
              <Dashboard
                isUserPlus={this.props.isUserPlus}
                STATE={this.props.STATE}
                CATEGORIES={this.props.CATEGORIES.CHILD}
                SPENDINGS={this.props.SPENDINGS}
                openFormCustom={(
                  op_id,
                  op_type = "category",
                  titleDialog = "Extract Dépenses Catégorie",
                  title = "MJB_spending_category.csv"
                ) =>
                  this.setState({
                    formDownload: true,
                    titleDialog,
                    title,
                    op_id,
                    op_type,
                  })
                }
              />
            )
          // <Tests8000 />
        }
        {page === "users" && menuList.includes(ADMIN_MENU["users"]) && (
          <UsersList
            {...this.props}
            notif={this.notif}
            createNewEmployee={this.createNewEmployee}
            // openFormDownload={(url, user_id, titleDialog = "Extract Historique", title = "MJB_credit_history.csv" ) => this.setState({formDownload: true, url, titleDialog, title, user_id })}
            handleDownload={this.handleDownloadUserHistory}
            downloading={this.state.downloading}
            // handleDownload={this.handleDownload}
            openFormDownloadTimesheet={(
              url,
              employeeID,
              titleDialog = "Extract Timesheet",
              title = "MJB_timesheet.csv"
            ) =>
              this.setState({
                formDownload: true,
                url,
                titleDialog,
                title,
                employeeID,
              })
            }
          />
        )}

        {page === "spendings" && menuList.includes(ADMIN_MENU["spendings"]) && (
          <SpendingsAdmin
            {...this.props}
            downloading={this.state.downloading}
            openFormDownload={(
              url,
              titleDialog = "Extract Dépenses",
              title = "MJB_depenses.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            notif={this.notif}
            createNewCategory={this.createNewCategory}
            createNewSupplier={this.createNewSupplier}
          />
        )}
        {page === "salary" && menuList.includes(ADMIN_MENU["salary"]) && (
          <SalariesList
            {...this.props}
            createNewCategory={this.createNewCategory}
            downloading={this.state.downloading}
            openFormDownload={(
              url,
              titleDialog = "Extract Salaires",
              title = "MJB_salaires.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            notif={this.notif}
          />
        )}
        {page === "categories" &&
          menuList.includes(ADMIN_MENU["categories"]) && (
            <CategoriesList
              {...this.props}
              downloading={this.state.downloading}
              handleDownload={this.handleDownload}
              openFormCustom={(
                op_id,
                op_type = "category",
                titleDialog = "Extract Dépenses Catégorie",
                title = "MJB_spending_category.csv"
              ) =>
                this.setState({
                  formDownload: true,
                  titleDialog,
                  title,
                  op_id,
                  op_type,
                })
              }
              notif={this.notif}
            />
          )}
        {page === "suppliers" && menuList.includes(ADMIN_MENU["suppliers"]) && (
          <SuppliersList
            {...this.props}
            downloading={this.state.downloading}
            handleDownload={this.handleDownload}
            openFormCustom={(
              op_id,
              op_type = "supplier",
              titleDialog = "Extract Dépenses Fournisseur",
              title = "MJB_spending_supplier.csv"
            ) =>
              this.setState({
                formDownload: true,
                titleDialog,
                title,
                op_id,
                op_type,
              })
            }
            notif={this.notif}
          />
        )}
        {page === "labels" && menuList.includes(ADMIN_MENU["labels"]) && (
          <LabelsList
            {...this.props}
            downloading={this.state.downloading}
            handleDownload={this.handleDownload}
            openFormCustom={(
              op_id,
              op_type = "label",
              titleDialog = "Extract Dépenses Label",
              title = "MJB_spending_label.csv"
            ) =>
              this.setState({
                formDownload: true,
                titleDialog,
                title,
                op_id,
                op_type,
              })
            }
            notif={this.notif}
          />
        )}
        {page === "banks" && menuList.includes(ADMIN_MENU["banks"]) && (
          <BanksList
            {...this.props}
            downloading={this.state.downloading}
            handleDownload={this.handleDownload}
            openFormDownload={(
              url,
              titleDialog = "Extract Banque",
              title = "MJB_tresorerie.csv",
              bank_id
            ) =>
              this.setState({
                formDownload: true,
                url,
                titleDialog,
                title,
                bank_id,
              })
            }
            notif={this.notif}
          />
        )}
        {page === "payments" && menuList.includes(ADMIN_MENU["payments"]) && (
          // <PaymentsList
          <PaymentsGeneral
            {...this.props}
            downloading={this.state.downloading}
            openFormDownload={(
              url,
              titleDialog = "Extract Paiements",
              title = "MJB_paiements.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            notif={this.notif}
          />
        )}
        {page === "advances" && menuList.includes(ADMIN_MENU["advances"]) && (
          <AdvancesGeneral
            {...this.props}
            downloading={this.state.downloading}
            openFormDownload={(
              url,
              titleDialog = "Extract Acomptes",
              title = "MJB_acomptes.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            notif={this.notif}
          />
        )}
        {page === "transfers" && menuList.includes(ADMIN_MENU["transfers"]) && (
          <TransfersList
            {...this.props}
            downloading={this.state.downloading}
            openFormDownload={(
              url,
              titleDialog = "Extract Transferts",
              title = "MJB_Transferts.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            notif={this.notif}
          />
        )}
        {page === "credits" && menuList.includes(ADMIN_MENU["credits"]) && (
          <CreditsGeneral
            {...this.props}
            downloading={this.state.downloading}
            openFormDownload={(
              url,
              titleDialog = "Extract Avances",
              title = "MJB_avances.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            notif={this.notif}
          />
        )}
        {page === "extracts" && menuList.includes(ADMIN_MENU["extracts"]) && (
          <ExtractsList
            {...this.props}
            downloading={this.state.downloading}
            handleDownload={this.handleDownload}
            openFormDownload={(
              url,
              titleDialog = "Extract Trésorerie",
              title = "MJB_tresorerie.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            notif={this.notif}
          />
        )}
        {/* {page === "imports" && menuList.includes(ADMIN_MENU["imports"]) && 
                    <ImportCSV 
                        {...this.props} 
                        // downloading={this.state.downloading} 
                        // handleDownload={this.handleDownload} 
                        // openFormDownload={(url, titleDialog = "Extract Trésorerie", title = "MJB_tresorerie.csv" ) => this.setState({formDownload: true, url, titleDialog, title })} 
                        notif={this.notif} 
                    />
                } */}
        {page === "projects" && menuList.includes(ADMIN_MENU["projects"]) && (
          <ProjectsList
            {...this.props}
            downloading={this.state.downloading}
            openFormCustom={(
              op_id,
              op_type = "project",
              titleDialog = "Extract Dépenses Projet",
              title = "MJB_spending_project.csv"
            ) =>
              this.setState({
                formDownload: true,
                titleDialog,
                title,
                op_id,
                op_type,
              })
            }
            openFormDownload={(
              url,
              project_id,
              titleDialog = "Extract Timesheet Projet",
              title = "MJB_timesheet_project.csv"
            ) =>
              this.setState({
                formDownload: true,
                url,
                titleDialog,
                title,
                project_id,
              })
            }
            openFormDownloadAll={(
              url,
              titleDialog = "Extract Projets",
              title = "MJB_projects.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            handleDownload={this.handleDownload}
            notif={this.notif}
          />
        )}
        {page === "projects_archived" &&
          menuList.includes(ADMIN_MENU["projects_archived"]) && (
            <ProjectsList
              {...this.props}
              showArchived
              downloading={this.state.downloading}
              openFormCustom={(
                op_id,
                op_type = "project",
                titleDialog = "Extract Dépenses Projet",
                title = "MJB_spending_project.csv"
              ) =>
                this.setState({
                  formDownload: true,
                  titleDialog,
                  title,
                  op_id,
                  op_type,
                })
              }
              openFormDownload={(
                url,
                project_id,
                titleDialog = "Extract Timesheet Projet",
                title = "MJB_timesheet_project.csv"
              ) =>
                this.setState({
                  formDownload: true,
                  url,
                  titleDialog,
                  title,
                  project_id,
                })
              }
              openFormDownloadAll={(
                url,
                titleDialog = "Extract Projets",
                title = "MJB_projects.csv"
              ) => this.setState({ formDownload: true, url, titleDialog, title })}
              handleDownload={this.handleDownload}
              notif={this.notif}
            />
          )}
        {page === "chantiers" && menuList.includes(ADMIN_MENU["chantiers"]) && (
          <ChantiersList
            {...this.props}
            downloading={this.state.downloading}
            openFormDownload={(
              url,
              chantier_id,
              titleDialog = "Extract Timesheet Projet",
              title = "MJB_timesheet_chantier.csv"
            ) =>
              this.setState({
                formDownload: true,
                url,
                titleDialog,
                title,
                chantier_id,
              })
            }
            handleDownload={this.handleDownload}
            notif={this.notif}
          />
        )}
        {page === "schedule" && menuList.includes(ADMIN_MENU["schedule"]) && (
          <ScheduleAdmin
            {...this.props}
            downloading={this.state.downloading}
            // handleDownload={this.handleDownload}
            openFormDownload={(
              url,
              titleDialog = "Extract Timesheet",
              title = "MJB_timesheet.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            notif={this.notif}
          />
        )}
        {page === "budget" && menuList.includes(ADMIN_MENU["budget"]) && (
          <BudgetGeneral
            {...this.props}
            downloading={this.state.downloading}
            handleDownload={(url, budget_year, title) =>
              this.handleDownloadBudget(url, title, budget_year)
            }
            notif={this.notif}
          />
        )}
        {page === "incomes" && menuList.includes(ADMIN_MENU["incomes"]) && (
          <IncomesList
            {...this.props}
            downloading={this.state.downloading}
            handleDownload={this.handleDownload}
            openFormDownload={(
              url,
              titleDialog = "Extract Recettes",
              title = "MJB_incomes.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            notif={this.notif}
          />
        )}
        {page === "factures" && menuList.includes(ADMIN_MENU["factures"]) && (
          <FacturesList
            {...this.props}
            downloading={this.state.downloading}
            handleDownload={this.handleDownload}
            openFormDownload={(
              url,
              titleDialog = "Extract Factures",
              title = "MJB_factures.csv"
            ) => this.setState({ formDownload: true, url, titleDialog, title })}
            notif={this.notif}
          />
        )}
        {page === "equipements" &&
          menuList.includes(ADMIN_MENU["equipements"]) && (
            <EquipementGeneral
              {...this.props}
              downloading={this.state.downloading}
              handleDownload={this.handleDownload}
              openFormDownload={(
                url,
                titleDialog = "Extract Equipements",
                title = "MJB_equipements.csv"
              ) =>
                this.setState({ formDownload: true, url, titleDialog, title })
              }
              notif={this.notif}
            />
          )}
        {page === "equipemployees" &&
          menuList.includes(ADMIN_MENU["equipements"]) && (
            <EquipementUsers
              {...this.props}
              downloading={this.state.downloading}
              handleDownload={this.handleDownload}
              openFormDownload={(
                url,
                titleDialog = "Extract Equipements",
                title = "MJB_equipements.csv"
              ) =>
                this.setState({ formDownload: true, url, titleDialog, title })
              }
              notif={this.notif}
            />
          )}
        {page === "demands" && menuList.includes(ADMIN_MENU["demands"]) && (
          <DemandGeneral
            downloading={this.state.downloading}
            // openFormDownload={(url, titleDialog = "Extract Demandes", title = "MJB_demands.csv" ) => this.setState({formDownload: true, url, titleDialog, title })}
            handleDownload={this.handleDownloadDemandSession}
            notif={this.notif}
            {...this.props}
          />
        )}
        {page === "society" && menuList.includes(ADMIN_MENU["society"]) && (
          <Society notif={this.notif} />
        )}

        {page === "spendings_demand" &&
          menuList.includes(ADMIN_MENU["spendings_demand"]) && (
            <div>
              <IframeV1
                key={this.state.refreshKey}
                token={localStorage.jwtToken_compta}
                url={
                  "/spending_demand" + (
                    this.state.spendingDemandId ? "/" + this.state.spendingDemandId : ""
                  )
                }
                title="Demandes de dépenses"
              />
            </div>
          )}

        {page === "teams" && menuList.includes(ADMIN_MENU["teams"]) && (
          <div>

<IframeV1
                key={this.state.refreshKey}
                token={localStorage.jwtToken_compta}
                url={
                "/teams"
              }
              title="team"
          
            />
          </div>
        )}
        {page === "feature_request" &&
          menuList.includes(ADMIN_MENU["feature_request"]) && (
            <JiraForm />
          )}
        {!menuList.includes(ADMIN_MENU[page]) &&
          !subMenuList.includes(page) &&
          (() => {
            const params = new URLSearchParams(window.location.search);
            const spendingDemandId = params.get("spending_demand_id");
            if (
              page === "spendings" &&
              spendingDemandId
            ) {
              return (
                <Redirect
                  to={`/spendings/new?spending_demand_id=${spendingDemandId}`}
                />
              );
            }
            return <PageNotFound />;
          })()}
      </SideBar>
    );
  }
}

function mapStateToProps(state) {
  // transform elements from store's state into props in this component
  return {
    currentUser: state.auth.user,
    isAdmin: state.auth.isAdmin,
    isUserPlus: state.auth.isUserPlus,
    isSuper: state.auth.isSuperAdmin,
    ACCESS: state.access,
    STATE: state.request,
    USERS: state.users,
    SPENDINGS: state.spendings.ADMIN,
    SPENDING_DEMANDS: state.spendingDemands.ADMIN,
    CATEGORIES: state.categories,
    SALARIES: state.salaries,
    EMPLOYEES: state.employees,
    SALARY_CATS: state.salary_cats,
    SUPPLIERS: state.suppliers,
    LABELS: state.labels,
    BANKS: state.banks,
    CREDITS: state.credits,
    DEBITS: state.debits,
    CHARGES: state.charges,
    PAYMENTS: state.payments,
    PAYMENT_DETAILS: state.payment_details,
    SERVICES: state.services,
    FUNCTIONS: state.functions,
    PROJECTS: state.projects,
    STEPS: state.steps,
    CHANTIERS: state.chantiers,
    TIMESHEETS: state.timesheets,
    ADVANCES: state.advances,
    ADVANCE_RETURNS: state.advanceReturns,
    BUDGETS: state.budgets,
    INCOMES: state.incomes,
    FACTURES: state.factures,
    TRANSFERS: state.transfers,
    POSTS: state.posts,
    LOCALISATIONS: state.localisations,
    VEHICULES: state.vehicules,
    IMMO_TAGS: state.immo_tags,
    EQUIPEMENTS: state.equipements,
    USAGES: state.usages,
    LOAN_DEMANDS: state.loanDemands.ALL,
    LOANS_DEMANDS_BY_EQUIP: state.loanDemands.BY_EQUIPEMENT,
    LOANS_DEMANDS_BY_USER: state.loanDemands.BY_USER,
    LOANS: state.loans.ALL,
    LOANS_BY_EQUIP: state.loans.BY_EQUIPEMENT,
    LOANS_BY_USER: state.loans.BY_USER,
    ARTICLES: state.articles,
    DEMANDS: state.demands,
    SESSIONS: state.sessions.ALL,
    CURRENT_SESSION: state.sessions.CURRENT,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchUsersByEmail,
      fetchUsers,
      newUser,
      deleteUser,
      updateUser,
      updateUserPassword,
      fetchParentCategories,
      fetchChildCategories,
      newCategory,
      updateCategory,
      toggleCategoryActive,
      fetchSuppliers,
      newSupplier,
      updateSupplier,
      fetchLabels,
      newLabel,
      updateLabel,
      fetchBanks,
      newBank,
      updateBank,
      fetchPayments,
      newPayment,
      newPaymentFullSupplier,
      updatePayment,
      deletePayment,
      fetchSpendings: fetchAdminSpendings,
      fetchSpendingPayments,
      newSpending,
      updateSpending,
      deleteSpending,
      fetchCredits,
      fetchDebits,
      newCredit,
      newSubCredit,
      fetchSubCredits,
      newDebit,
      updateDebit,
      recalcCredits,
      deleteCredit,
      deleteDebit,
      fetchPaymentDetails,
      fetchEmployees,
      newEmployee,
      updateEmployee,
      fetchServices,
      newService,
      fetchFunctions,
      newFunction,
      fetchSalaries,
      newSalary,
      updateSalary,
      deleteSalary,
      fetchSalaryCats,
      newSalaryCat,
      updateSalaryCat,
      fetchCharges,
      newPaymentCharge,
      newPaymentSalary,
      newAccess,
      fetchAccess,
      updateAccess,
      deleteAccess,
      fetchProjects,
      updateProject,
      newProject,
      addSpendingToProject,
      fetchProjectSteps,
      newProjectStep,
      deleteProjectStep,
      fetchChantiers,
      updateChantier,
      addSpendingToChantier,
      getChantierPartList,
      fetchTimesheets,
      updateTimesheet,
      newTimesheet,
      newSupplierAdvance,
      deleteSupplierAdvance,
      fetchSupplierAdvances,
      newAdvanceReturn,
      fetchAdvanceReturns,
      deleteAdvanceReturn,
      fetchParentCategoriesSpent,
      updateActiveBudget,
      newBudget,
      fetchBudgets,
      newPost,
      fetchPosts,
      updatePost,
      deletePost,
      newIncome,
      updateIncome,
      fetchIncomePayments,
      fetchIncomes,
      deleteIncome,
      importIncomes,
      newFacture,
      updateFacture,
      fetchFactures,
      deleteFacture,
      newTransfer,
      updateTransfer,
      fetchTransfers,
      deleteTransfer,

      newEquipement,
      updateEquipement,
      fetchEquipements,
      deleteEquipement,
      updateEquipementPics,
      updateVehiculePics,
      newLocalisation,
      updateLocalisation,
      fetchParentLocalisations,
      fetchChildLocalisations,
      newVehicule,
      updateVehicule,
      fetchVehicules,
      fetchImmoTags,
      newLoan,
      // updateLoan,
      updateResaLoanUser,
      updateResaLoanAdmin,
      endLoan,
      fetchLoans,
      fetchEquipementLoans,
      fetchUserLoansAdmin,
      updateDeleteLineAdmin,
      newLoanDemand,
      updateLoanDemand,
      fetchLoanDemands,
      fetchUserLoanDemandsAdmin,
      fetchEquipementLoanDemands,

      // newUsage,
      // updateUsage,
      // fetchUsages,

      newArticle,
      updateArticle,
      fetchArticles,
      updateArticlePics,
      newSession,
      updateSession,
      updateSessionStatus,
      fetchSessions,
      newUserDemand,
      updateUserDemand,
      fetchAllDemands,
      updateDemandLoanStatus,
      newLoanResa,

      // SPENDING_DEMAND
      fetchAdminSpendingsDemand,
      fetchSingleSpendingDemand,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard); // RequireAdmin
